import { defineMessages } from "react-intl";

export const shortcutsMessages = defineMessages({
  search: {
    id: "gx6b6x",
    defaultMessage: "Search",
    description: "search shortcut",
  },
  playground: {
    id: "Cn6l5R",
    defaultMessage: "Playground",
    description: "playground shortcut",
  },
});
